import { render, staticRenderFns } from "./disciplineUser.vue?vue&type=template&id=53df17d9&"
import script from "./disciplineUser.vue?vue&type=script&lang=js&"
export * from "./disciplineUser.vue?vue&type=script&lang=js&"
import style0 from "./disciplineUser.vue?vue&type=style&index=0&id=53df17d9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports